<template>
    <page>
        <module title="订单商品评价详情">
            <div v-if="evaluateInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="订单号">{{evaluateInfo.order_number}}</c-detail-item>

                    <c-detail-item label="评价时间">{{evaluateInfo.create_date}}</c-detail-item>

                    <c-detail-item label="评价会员昵称/头像">
                        <c-image :src="evaluateInfo.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                        <span>{{evaluateInfo.nick_name}}</span>
                    </c-detail-item>

                    <c-detail-item label="评价会员手机">{{evaluateInfo.user_manage_mobilephone}}</c-detail-item>

                    <c-detail-item label="评分">{{evaluateInfo.score}}</c-detail-item>

                    <c-detail-item label="商品名称">{{evaluateInfo.product_name}}</c-detail-item>

                    <c-detail-item label="查看数量">{{evaluateInfo.view_count}}</c-detail-item>

                    <c-detail-item label="点赞数量">{{evaluateInfo.thumb_count}}</c-detail-item>

                    <c-detail-item label="评价内容" full>{{evaluateInfo.evaluate_comment}}</c-detail-item>
                </c-detail>

                <c-detail title="评价图片信息" v-if="imageList && imageList.length > 0">
                    <c-detail-item  full>
                        <div  class="flex-center-cross">
                            <c-image  v-for="(item, i) in imageList" :src="item.file_url" preview size="60" style="margin-right: 10px;"></c-image>
                        </div>
                    </c-detail-item>
                </c-detail>

                <c-detail title="评价视频信息" v-if="videoList && videoList.length > 0">
                    <c-detail-item  full>
                        <div  class="flex-center-cross">
                            <c-image  v-for="(item, i) in videoList" :src="item.file_url" preview size="60" style="margin-right: 10px;"></c-image>
                        </div>
                    </c-detail-item>
                </c-detail>

                <c-detail title="评价标签信息">
                    <c-detail-item  label="标签信息" full>
                        {{evaluateInfo.tag_name}}
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'order_evaluate_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                evaluateInfo: '',
                evaluateMediaList: [],
                imageList: [],
                videoList: [],
                typeType: [{
                    name: '图片',
                    value: 1
                },{
                    name: '视频',
                    value: 2
                }
                ]
            }
        },

        computed: {
            ...mapState(['dict']),

            typeText() {
                var state = {};
                this.typeType.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        watch: {
            id() {
                this.getEvaluateDetail();
            }
        },

        mounted() {
            this.getEvaluateDetail();
        },

        methods: {
            getEvaluateDetail() {
                this.request({
                    url: '/orderEvaluate/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.evaluateInfo = data;
                        this.imageList = data.image_list;
                        this.videoList = data.video_list;
                    }
                });
            }
        }
    }
</script>
